import React, { Component } from "react";

export class Step6Software extends Component {
  constructor(props) {
    super(props);

    this.state = {
      softwareType: props.formData.softwareType || "",
      users: props.formData.users || "",
      platform: props.formData.platform || "",
      modules: props.formData.modules || [],
      adminPanel: props.formData.adminPanel || "Yes",
      loginSystem: props.formData.loginSystem || "Yes",
      reports: props.formData.reports || "Yes",
      apiIntegration: props.formData.apiIntegration || "No",
      cloudHosting: props.formData.cloudHosting || "No",
      description: props.formData.softwareDescription || "",
      error: "",
    };
  }

  handleChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value,
      error: "",
    });
  };

  handleCheckbox = (e) => {
    const { value, checked } = e.target;

    let modules = [...this.state.modules];

    if (checked) {
      modules.push(value);
    } else {
      modules = modules.filter((item) => item !== value);
    }

    this.setState({
      modules,
      error: "",
    });
  };

  handleNext = () => {
    if (!this.state.softwareType) {
      this.setState({
        error: "Please select Software Type.",
      });
      return;
    }

    this.props.updateFormData({
      softwareType: this.state.softwareType,
      users: this.state.users,
      platform: this.state.platform,
      modules: this.state.modules,
      adminPanel: this.state.adminPanel,
      loginSystem: this.state.loginSystem,
      reports: this.state.reports,
      apiIntegration: this.state.apiIntegration,
      cloudHosting: this.state.cloudHosting,
      softwareDescription: this.state.description,
    });

    this.props.nextStep();
  };

  render() {
    const moduleList = [
      "Dashboard",
      "User Management",
      "Employee Management",
      "HR Management",
      "Attendance",
      "Payroll",
      "Inventory",
      "Billing",
      "Sales",
      "Purchase",
      "CRM",
      "Lead Management",
      "Customer Management",
      "Vendor Management",
      "Reports",
      "Analytics",
      "Notifications",
      "Role & Permission",
      "Document Management",
      "Settings"
    ];

    return (
      <div className="container py-4">
        <div className="card shadow border-0">

          <div className="card-header bg-primary text-white">
            <h3 className="mb-0">
              Step 6 : Software Development Requirements
            </h3>
          </div>

          <div className="card-body">

            <div className="row">

              {/* Software Type */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Software Type <span className="text-danger">*</span>
                </label>

                <select
                  className="form-select"
                  name="softwareType"
                  value={this.state.softwareType}
                  onChange={this.handleChange}
                >
                  <option value="">Select Software Type</option>
                  <option>School ERP</option>
                  <option>Hospital Management</option>
                  <option>HRMS</option>
                  <option>CRM</option>
                  <option>Inventory Management</option>
                  <option>Billing Software</option>
                  <option>Restaurant Management</option>
                  <option>Gym Management</option>
                  <option>Retail POS</option>
                  <option>Real Estate CRM</option>
                  <option>Custom Software</option>
                </select>
              </div>

              {/* Users */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Expected Users
                </label>

                <select
                  className="form-select"
                  name="users"
                  value={this.state.users}
                  onChange={this.handleChange}
                >
                  <option value="">Select Users</option>
                  <option>1 - 10</option>
                  <option>11 - 25</option>
                  <option>26 - 50</option>
                  <option>51 - 100</option>
                  <option>100+</option>
                </select>
              </div>

              {/* Platform */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Platform
                </label>

                <select
                  className="form-select"
                  name="platform"
                  value={this.state.platform}
                  onChange={this.handleChange}
                >
                  <option value="">Select Platform</option>
                  <option>Web Application</option>
                  <option>Desktop Application</option>
                  <option>Web + Mobile</option>
                </select>
              </div>

              {/* Admin Panel */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Admin Panel
                </label>

                <select
                  className="form-select"
                  name="adminPanel"
                  value={this.state.adminPanel}
                  onChange={this.handleChange}
                >
                  <option>Yes</option>
                  <option>No</option>
                </select>
              </div>

              {/* Login */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Login System
                </label>

                <select
                  className="form-select"
                  name="loginSystem"
                  value={this.state.loginSystem}
                  onChange={this.handleChange}
                >
                  <option>Yes</option>
                  <option>No</option>
                </select>
              </div>

              {/* Reports */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Reports & Analytics
                </label>

                <select
                  className="form-select"
                  name="reports"
                  value={this.state.reports}
                  onChange={this.handleChange}
                >
                  <option>Yes</option>
                  <option>No</option>
                </select>
              </div>

              {/* API */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Third Party API Integration
                </label>

                <select
                  className="form-select"
                  name="apiIntegration"
                  value={this.state.apiIntegration}
                  onChange={this.handleChange}
                >
                  <option>No</option>
                  <option>Yes</option>
                </select>
              </div>

              {/* Cloud */}
              <div className="col-md-6 mb-3">
                <label className="form-label">
                  Cloud Hosting
                </label>

                <select
                  className="form-select"
                  name="cloudHosting"
                  value={this.state.cloudHosting}
                  onChange={this.handleChange}
                >
                  <option>No</option>
                  <option>Yes</option>
                </select>
              </div>

              {/* Modules */}
              <div className="col-12 mb-4">
                <label className="form-label fw-bold">
                  Required Modules
                </label>

                <div className="row">

                  {moduleList.map((module, index) => (
                    <div className="col-md-4 mb-2" key={index}>

                      <div className="form-check">

                        <input
                          type="checkbox"
                          className="form-check-input"
                          id={`module${index}`}
                          value={module}
                          checked={this.state.modules.includes(module)}
                          onChange={this.handleCheckbox}
                        />

                        <label
                          className="form-check-label"
                          htmlFor={`module${index}`}
                        >
                          {module}
                        </label>

                      </div>

                    </div>
                  ))}

                </div>
              </div>

              {/* Description */}
              <div className="col-12 mb-3">
                <label className="form-label">
                  Project Description
                </label>

                <textarea
                  rows="5"
                  className="form-control"
                  name="description"
                  placeholder="Describe your software requirements..."
                  value={this.state.description}
                  onChange={this.handleChange}
                />
              </div>

            </div>

            {this.state.error && (
              <div className="alert alert-danger">
                {this.state.error}
              </div>
            )}

            <hr />

            <div className="d-flex justify-content-between">

              <button
                className="btn btn-outline-secondary"
                onClick={this.props.prevStep}
              >
                Previous
              </button>

              <button
                className="btn btn-primary"
                onClick={this.handleNext}
              >
                Next
              </button>

            </div>

          </div>

        </div>
      </div>
    );
  }
}

export default Step6Software;